import { FC, useContext, useEffect, useState } from "react";
import BAAContent from "src/components/baaContent";
import { AuthContext } from "src/context/authContext";
import { ToastContext } from "src/context/toastContext";
import { ToastTypes } from "src/types";



const UpdatedBAAModal: FC<{ isModalVisible: boolean; onClose: () => void; }> = ({ isModalVisible, onClose }): JSX.Element => {
  const [firstname, updateFirstname] = useState<string>("")
  const [lastname, updatelastname] = useState<string>("")
  const [firstErr, updateFirstErr] = useState<string>("")
  const [lastErr, updatelastErr] = useState<string>("")
  
  const { userData } = useContext(AuthContext)
  const { showToast } = useContext(ToastContext)

  useEffect(() => {
    if (userData) {
      updateFirstname(userData.firstname)
      updatelastname(userData.lastname)
    }
  }, [userData])


  const updateBaaData = () => {
    if (firstname.length > 0 && lastname.length > 0) {
      updateFirstErr("")
      updatelastErr("")

      //:- Saving Cookie for newbaa12visited
      const nextDay = new Date(new Date().getTime());
      nextDay.setDate(nextDay.getDate() + 1);
      const expires = nextDay;
      document.cookie = `newbaa12visited=true;expires=${expires.toUTCString()}`;

      //:- API call left
      showToast(["User updated"], ToastTypes.INFO)
      onClose()
    } else {
      if (firstname.length === 0) updateFirstErr("First name is required")
      if (lastname.length === 0) updatelastErr("Last name is required")
    }
  }

  return (
    <div 
      className={`modal fade ${isModalVisible ? 'show show-modal' : ''}`}
      style={{ backgroundColor: "rgba(0, 0, 0, 0)" }} onClick={onClose}
    >
      <div className="modal-dialog modal-lg modal-dialog-centered" onClick={(e) => e.stopPropagation()}>
        <div className="modal-content shadow">
          <div className="modal-header">
            <p className="modal-title h1 text-success fw-medium">
              Updated BAA Approval
            </p>
            <button
              type="button"
              className="btn-close"
              onClick={onClose}
            ></button>
          </div>
          <div className="modal-body">
            <p>
              Our Business Associate Agreement has been updated. Please enter your first and last name below, 
              then click 'Accept' to approve the new version of the agreement.
            </p>

            <div className="card p-0" style={{ height: 400 }}>
              <div className="card-header bg-success-subtle">
                <h3 className="text-black m-0">
                  Business Associates Agreement
                </h3>
              </div>
              <div className="card-body overflow-auto">
                <BAAContent />
              </div>
            </div>

            <div className="row mt-3">
              <div className="col-sm-6">
                <input 
                  type="text" name="firstname" id="firstname" 
                  placeholder="First Name" className={`form-control ${firstErr.length > 0 ? "is-invalid" : ""} mb-2`}
                  value={firstname} onChange={(e) => {
                    if (e.target.value.length > 0 && firstErr.length > 0) updateFirstErr("")
                    updateFirstname(e.target.value)
                  }}
                  onBlur={() => {
                    if (firstname.length > 0 && firstErr.length > 0) updateFirstErr("")
                    if (firstname.length === 0 && firstErr.length === 0) updateFirstErr("First name is required")
                  }}
                />
                {firstErr.length > 0 ? (
                  <div dangerouslySetInnerHTML={{ __html: firstErr }} className="text-danger text-small mt-2 "></div>
                ) : null}
              </div>
              <div className="col-sm-6">
                <input 
                  type="text" name="lastname" id="lastname" 
                  placeholder="Last Name" className={`form-control ${lastErr.length > 0 ? "is-invalid" : ""} mb-2`}
                  value={lastname} onChange={(e) => {
                    if (e.target.value.length > 0 && lastErr.length > 0) updatelastErr("")
                    updatelastname(e.target.value)
                  }}
                  onBlur={() => {
                    if (lastname.length > 0 && lastErr.length > 0) updatelastErr("")
                    if (lastname.length === 0 && lastErr.length === 0) updatelastErr("Last name is required")
                  }}
                />
                {lastErr.length > 0 ? (
                  <div dangerouslySetInnerHTML={{ __html: lastErr }} className="text-danger text-small mt-2 "></div>
                ) : null}
              </div>
            </div>
            <button type="button" onClick={updateBaaData} className="btn btn-blue mt-2">Accept</button>
          </div>
        </div>
      </div>
    </div>
  )
}

export default UpdatedBAAModal
